<template lang="pug">
v-dialog(v-model='opened' max-width='360' persistent)
  v-card
    v-card-title(class='headline') Настройки холста
    v-container(grid-list-xl)
      v-layout(wrap)
        v-flex(xs12 sm6 md6)
          v-text-field(v-model='size.x' label='Смещение X' mask='####')
        v-flex(xs12 sm6 md6)
          v-text-field(v-model='size.y' label='Смещение Y' mask='####')
        v-flex(xs12 sm6 md6)
          v-text-field(v-model='size.w' label='Ширина' mask='####')
        v-flex(xs12 sm6 md6)
          v-text-field(v-model='size.h' label='Высота' mask='####')
    v-card-actions
      v-spacer
      v-btn(color='default darken-1' flat='flat' @click='$emit("undo")') Отмена
      v-btn(color='green darken-1' flat='flat' @click='$emit("ok", size)') Ок
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    },

    viewBox: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    size: { x: 0, y: 0, w: 0, h: 0 }
  }),

  created() {
    this.setViewBox()
  },

  methods: {
    setViewBox() {
      this.size = {
        ...this.viewBox
      }
    }
  },

  watch: {
    opened(status) {
      if (!status) {
        this.setViewBox()
      }
    }
  }
}
</script>
